import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';
import { media } from '../../styles/breakpoints-2026';
import {
  PAGE_MAX_WIDTH_2026,
  RAIL_WIDTH_2026,
  RAIL_WIDTH_LARGE_2026,
  pageWrapper2026,
  breadcrumbBar2026,
  breadcrumbs2026,
} from '../layout/layout.styles';

const { spacing, colors } = tokens;

const MAIN_COLUMN_MAX_WIDTH = 780; // Section_Overview width at the 1248 frame
const TABLET_INLINE_PHOTO_SIZE = 188; // Agent avatar next to Section_Overview at the 768 frame
const NARROW_TABLET_INLINE_PHOTO_SIZE = 124;

const GUTTER_DESKTOP = spacing.xl;
const GUTTER_WIDE = spacing.xxl;

export const wrapper = pageWrapper2026;

export const breadcrumbBar = breadcrumbBar2026;

export const breadcrumbs = breadcrumbs2026;

export const mainContainer = css`
  box-sizing: border-box;
  width: 100%;
  max-width: ${PAGE_MAX_WIDTH_2026}px;
  margin: 0 auto;
`;

export const bodyContainer = css`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    'photo'
    'details'
    'tiles'
    'content';
  row-gap: ${spacing.l};
  padding: ${spacing.l} ${spacing.m} ${spacing.xxl};

  ${media('>=tablet', '<=tablet-narrow')} {
    grid-template-columns: minmax(0, 1fr) ${NARROW_TABLET_INLINE_PHOTO_SIZE}px;
    grid-template-areas:
      'details photo'
      'tiles tiles'
      'content content';
    column-gap: ${spacing.l};
    row-gap: ${spacing.m};
  }

  ${media('>tablet-narrow', '<desktop')} {
    grid-template-columns: minmax(0, 1fr) ${TABLET_INLINE_PHOTO_SIZE}px;
    grid-template-areas:
      'details photo'
      'tiles photo'
      'content content';
    column-gap: ${spacing.xl};
  }

  ${media('>=desktop')} {
    grid-template-columns:
      minmax(0, ${MAIN_COLUMN_MAX_WIDTH}px)
      ${RAIL_WIDTH_2026}px;
    grid-template-areas:
      'details sidebar'
      'tiles sidebar'
      'content sidebar';
    justify-content: space-between;
    align-items: start;
    column-gap: ${GUTTER_DESKTOP};
  }

  ${media('>lrg-desktop')} {
    grid-template-columns:
      minmax(0, ${MAIN_COLUMN_MAX_WIDTH}px)
      ${RAIL_WIDTH_LARGE_2026}px;
    column-gap: ${GUTTER_WIDE};
  }
`;

export const details = css`
  grid-area: details;
  min-width: 0;
`;

export const tiles = css`
  grid-area: tiles;
  min-width: 0;
`;

export const content = css`
  grid-area: content;
  display: flex;
  flex-direction: column;
  gap: ${spacing.l};
  min-width: 0;

  ${media('>=tablet', '<=tablet-narrow')} {
    margin-top: calc(${spacing.l} - ${spacing.m});
  }
`;

export const sidebar = css`
  display: contents;

  ${media('>=desktop')} {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    gap: ${spacing.m};
  }
`;

export const photo = css`
  grid-area: photo;

  ${media('<desktop')} {
    align-self: start;
  }

  > div {
    aspect-ratio: 1;
    width: 100%;
  }
`;

export const sidebarContact = css`
  display: none;

  ${media('>=desktop')} {
    display: block;
  }
`;

export const divider = css`
  border-top: 1px solid ${colors.neutral.trim.default};
`;

export const stackedContact = css`
  ${media('>=desktop')} {
    display: none;
  }
`;
